
































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import Apis from '@/Apis/_'
import EventBus from '@/plugins/EventBus'
import ModalActionConfirm from '@/components/modals/ModalActionConfirm.vue'
import ModalLogsAlteracaoTipoUsuario from '@/components/Configuracoes/ModalLogsAlteracaoTipoUsuario.vue'
import { TIPO_USUARIO_LABELS } from '@/components/Configuracoes/tipoUsuarioLabels'

interface TipoUsuarioOption {
  label: string
  value: string
}

@Component({ components: { ModalActionConfirm, ModalLogsAlteracaoTipoUsuario } })
export default class ModalAlterarTipoUsuario extends Vue {
  @Prop({ required: true }) visible!: boolean
  @Prop({ required: true }) usuarioId!: string
  @Prop({ default: '' }) tipoAtual!: string

  novoTipoSelecionado: string = ''
  loading: boolean = false
  showConfirmDialog: boolean = false
  showLogsModal: boolean = false

  get tiposDisponiveis(): TipoUsuarioOption[] {
    return Object.entries(TIPO_USUARIO_LABELS).map(([value, label]) => ({ label, value }))
  }

  get tipoAtualLabel(): string {
    return TIPO_USUARIO_LABELS[this.tipoAtual] || this.tipoAtual || '—'
  }

  @Watch('visible')
  onVisibleChange(val: boolean) {
    if (!val) {
      this.novoTipoSelecionado = ''
      this.showConfirmDialog = false
      this.showLogsModal = false
    }
  }

  confirmar() {
    if (!this.novoTipoSelecionado) return
    this.showConfirmDialog = true
  }

  async executarAlteracaoTipo() {
    this.showConfirmDialog = false
    this.loading = true
    try {
      const response = await Apis.Agendamento.SuporteApi.alterarTipoUsuario({
        idUsuarioParaAlterar: this.usuarioId,
        tipoUsuarioNovo: this.novoTipoSelecionado,
      })
      if (response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Tipo de usuário alterado com sucesso!', icon: 'done', color: '#2E7D32' })
        this.$emit('onConfirm', this.novoTipoSelecionado)
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu erro ao alterar o tipo do usuário.', icon: 'warning', color: '#C62828' })
      }
    } finally {
      this.loading = false
    }
  }
}
